/**src\infrastructure\config\api.config.ts
 * API Configuration
 *
 * Centralized configuration for API-related settings.
 */

import { env } from './env';

export const apiConfig = {
  baseURL: env.api.baseURL,
  timeout: env.api.timeout,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
};

/**
 * API Endpoints
 */
export const API_ENDPOINTS = {
  users: {
    base: '/users',
    byId: (id: string) => `/users/${id}`,
    byEmail: (email: string) => `/users?email=${email}`,
  },
  auth: {
    login: '/auth/login',
    logout: '/auth/logout',
    refresh: '/auth/refresh',
    me: '/auth/me',
  },
  incidentes: {
    base: 'incidente',
    byId: (id: string) => `/incidente/${id}`,
  },
  ubicacion: {
    base: 'ubicacion',
    byId: (id: string) => `/ubicacion/${id}`,
  },
  simple: {
    base: (tabla: string) => `/simple/${tabla}`,
    byId: (tabla:string, id: string) => `/simple/${tabla}/${id}`,
  },
  congrupo: {
    base: (tabla: string) => `/congrupo/${tabla}`,
    bygroup: (tabla: string, group: string) => `/congrupo/${tabla}/${group}`
  },
  equipos: {
    base: 'equipo',
    byId: (id: string) => `/equipo/${id}`,
  },
  repuesto: {
    base: 'repuesto',
    byId: (id: string) => `/repuesto/${id}`,
  },
  visitas: {
    base: 'visita',
    byId: (id: string) => `/visita/${id}`,
  },

} as const;

